export const parseAuthError = str => ({
  error: str?.match(/error="([^"]+)"/)?.[1] ?? '',
  errorDescription: str?.match(/error_description="([^"]+)"/)?.[1] ?? null,
});
